<template>
  <div class="popup-form">
    <div class="content-form-popup">
      <div class="header-text">
        <button type="button" class="back-button-wrapper pointer" aria-label="Zavrieť konzultáciu" @click="closePopup">
          <img
            class="nav-link-icon filter-primary"
            src="@/images/modal-close.svg"
            alt=""
          />
        </button>
        <div class="blackcolor pop-800">{{ translateEventType(payload.event.type) }}</div>
        <button v-if="sliceZeros(payload.event.start.value) !== sliceZeros(eventData.start)" class="w-button" form="event-changes">Uložiť</button>
      </div>
      <button v-if="payload.client" type="button" class="client-name-block consultation-client-button" @click="openClient">
        <img
          src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png"
          loading="lazy"
          alt=""
          class="image-10"
        />
        <div class="div-block-28">
          <div class="light-text lightgrey">
            Klient
            <div class="blc-color">
              <strong>{{ payload.client.first_name }} {{ payload.client.last_name }}</strong>
              <span class="client-details-hint">Zobraziť údaje a email →</span>
            </div>
          </div>
        </div>
      </button>
      <div v-else class="availability-status">
        <strong>Voľný termín pre klientov</strong>
        <span>Termín zatiaľ čaká na rezerváciu.</span>
      </div>
      <form id="event-changes" @submit.prevent="saveEvent">
        <div
          class="input-group mt-2"
        >
          <label for="podnikamOd" class="field-label"
          >Termín udalosti</label
          ><input
          type="datetime-local"
          v-model="eventData.start"
          :min="todayLong"
          class="text-input w-input date-input"
          maxlength="256"
          name="podnikamOd"
          data-name="podnikamOd"
          id="podnikamOd"
          required
        />
        </div>
      </form>
<!--        <div class="div-block-28">-->
<!--          <div class="light-text lightgrey">-->
<!--            Termín:-->
<!--          </div>-->
<!--          <div class="blc-color pop-700">-->
<!--            {{ transformDate() }}-->
<!--          </div>-->
<!--        </div>-->
      <div class="non-input-block">
        <div v-if="payload.event.type === 'online_konzultacia'">
          <div class="small-text light">
            Video call:
          </div>
          <template v-if="!payload.event.is_available_for_booking">
          <button
            type="button"
            class="join-call-button"
            :disabled="joining"
            @click="joinCall"
          >
            {{ joining ? 'Pripájam…' : 'Pripojiť sa cez Daily' }}
          </button>
          <button v-if="payload.client" type="button" class="copy-call-button" :disabled="copying" @click="copyClientLink">{{ copying ? 'Pripravujem odkaz…' : copied ? 'Odkaz skopírovaný ✓' : 'Skopírovať odkaz pre klienta' }}</button>
          <p v-if="copyError" class="join-call-note" role="status">{{ copyError }}</p>
          <div v-if="manualLink" class="manual-call-link">
            <label for="client-call-link">Odkaz pre klienta — označte a skopírujte:</label>
            <textarea id="client-call-link" readonly :value="manualLink" @focus="$event.target.select()" />
          </div>
          <p class="join-call-note">Miestnosť sa otvorí 15 minút pred začiatkom konzultácie.</p>
          </template>
          <div v-else class="pop-700 blc-color font-size-16">
            Link sa vytvorí automaticky po rezervácii klientom.
          </div>
        </div>
        <div v-else>
          <div class="small-text light">
            Iná adresa:
          </div>
          <a
            class="pop-900 blc-color font-size-16 pointer overflow-hidden"
            :href="'https://www.google.com/maps/place/?q=place_id:' + payload.event.meta?.placeId"
            target="_blank"
            v-if="payload.event.meta?.placeId"
          >
            Navigovať
          </a>
          <div
            v-if="payload.event.meta?.addressMeta"
            class="pop-700 blc-color font-size-14"
          >
            {{ getAddressModified(payload.event.meta.addressMeta) }}
          </div>
          <div v-else class="pop-700 blc-color font-size-16">
            Adresa {{ translateEventType(payload.event.type, 'u').toLowerCase() }} nebola špecifikovaná
          </div>
        </div>
      </div>
      <div class="section-title pointer noselect">
        <span @click="deleteEvent" class="bold bl-color">
          Vymazať udalosť
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import translateFromDBValue from "../../../../../mixins/translateFromDBValue";
import api from "@/services/apiConfig";
import propertyFilters from "../../../../../mixins/propertyFilters";
import {joinCalendarEvent} from "@/services/brokerService";

export default {
  name: "ExtendedViewPopUp",

  props: {
    payload: Object,
    type: Object,
  },
  mixins: [
    translateFromDBValue,
    propertyFilters,
  ],
  mounted() {
    const d = new Date();
    this.todayLong = [this.addZero(d.getFullYear()), this.addZero(d.getMonth() + 1), this.addZero(d.getDate())].join('-') + "T" + [this.addZero(d.getHours()), this.addZero(d.getMinutes())].join(':');
    const originalStart = new Date(this.payload.event.start.value);
    const originalEnd = this.payload.event.end?.value
      ? new Date(this.payload.event.end.value)
      : new Date(originalStart.getTime() + 30 * 60000);
    this.durationMinutes = Math.max(1, Math.round((originalEnd - originalStart) / 60000));
    this.eventData.start = this.payload.event.start.value;
  },
  watch: {
    'eventData.start'(newStart) {
      const date = new Date(newStart);
      date.setMinutes(date.getMinutes() + this.durationMinutes);
      this.eventData.end = this.formatLocalDateTime(date);
    },
  },
  methods: {
    openClient() {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: {client: true}, payload: this.payload.client,
        component: "UserManagerPopUp", rules: [],
      });
    },
    async copyClientLink() {
      if (this.copying) return;
      this.copying = true; this.copied = false; this.copyError = ''; this.manualLink = '';
      try {
        const response = await api.post(`/calendar-event/${this.payload.event.id}/client-link/`, {client: this.payload.client.id});
        const url = response.data.url;
        if (!url || !url.startsWith('https://')) throw new Error('Missing URL');
        try {
          await navigator.clipboard.writeText(url);
          this.copied = true;
        } catch {
          this.manualLink = url;
          this.copyError = 'Prehliadač nepovolil automatické kopírovanie. Odkaz môžete skopírovať z poľa nižšie.';
        }
      } catch (e) {
        this.copyError = e.response?.data?.detail || 'Odkaz sa nepodarilo pripraviť. Skúste znova.';
      } finally { this.copying = false; }
    },
    async joinCall() {
      this.joining = true;
      try {
        const response = await joinCalendarEvent(this.payload.event.id);
        window.open(response.url, '_blank', 'noopener');
      } catch (e) {
        this.$store.commit("appState/setSuccessMessage", {
          text: e.response?.data?.detail || "Videohovor sa nepodarilo otvoriť",
          type: "error"
        });
      } finally {
        this.joining = false;
      }
    },
    waitForUserPermission () {
      return new Promise((resolve) => {
        const int = setInterval(() => {
          const userConfirmation = this.$store.getters["appState/getUserConfirmation"];
          if (userConfirmation === true) {
            this.$store.commit("appState/setUserConfirmation", null);
            clearInterval(int);
            resolve(true);
          } else if (userConfirmation === false) {
            this.$store.commit("appState/setUserConfirmation", null);
            clearInterval(int);
            resolve(false);
          }
        }, 100);
      });
    },
    showDialogToUser (event, messageText) {
      this.$store.commit("appState/setSuccessMessage", {
        text: messageText,
        type: "confirmation"
      });
    },
    transformDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', {
        day: 'numeric', month: 'short', year: 'numeric', hour: "numeric", minute: "numeric"
      });
    },
    async deleteEvent() {
      this.showDialogToUser();
      const userPermission = await this.waitForUserPermission();
      if (!userPermission) return;
      this.$root.$emit("event-delete", {event: this.payload.event, checkEventChange: false});
      this.closePopup();
    },
    isEventMovePossible(event) {
      if (this.eventData.start === this.payload.event.start.value) return false;
      const isFutureDate = event.start.value > this.todayFull;
      if (!isFutureDate) {
        this.$store.commit("appState/setSuccessMessage", {
          text: `Zadajte budúci dátum`,
          type: "error"
        });
        return false;
      }
      return true;
    },
    async saveEvent() {
      let newEventData = JSON.parse(JSON.stringify(this.payload.event));
      const messageText = `Naozaj chcete presunúť ${this.translateEventType(newEventData.type).toLowerCase()} na ${this.transformDate(this.eventData.start)}`
      this.showDialogToUser(newEventData, messageText);
      const userPermission = await this.waitForUserPermission();
      if (!userPermission) return;
      newEventData = {
        ...newEventData,
        start: this.eventData.start,
        end: this.eventData.end,
      };
      this.$store.dispatch("clientsEvents/moveEvent", newEventData);
      this.closePopup();
    },
    sliceZeros(start) {
      if (!start) return;
      return start.slice(0,16);
    },
    addZero (value) {
      if (value < 10) {
        return '0' + value;
      }
      return value;
    },
    formatLocalDateTime(date) {
      return [date.getFullYear(), this.addZero(date.getMonth() + 1), this.addZero(date.getDate())].join('-')
        + 'T'
        + [this.addZero(date.getHours()), this.addZero(date.getMinutes()), '00'].join(':');
    },
    closePopup () {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
  },
  data: () => ({
    todayLong: null,
    todayFull: null,
    durationMinutes: 30,
    joining: false,
    copying: false,
    copied: false,
    copyError: '',
    manualLink: '',
    eventData: {
      start: null,
      end: null,
    }
  }),
}
</script>

<style lang="scss" scoped>
.consultation-client-button {width:100%; border:1px solid transparent; text-align:left; color:var(--app-text); font:inherit; cursor:pointer;}
.consultation-client-button:hover {border-color:var(--app-primary);}
.consultation-client-button:focus-visible, .copy-call-button:focus-visible {outline:2px solid var(--app-primary); outline-offset:3px;}
.client-details-hint {display:block; margin-top:4px; font-size:12px; color:var(--app-primary);}
.copy-call-button {width:100%; margin-top:10px; padding:11px 16px; border:1px solid var(--app-border, #375373); border-radius:12px; background:transparent; color:var(--app-primary, #69b9ff); font:inherit; font-size:14px; cursor:pointer;}
.copy-call-button:disabled {opacity:.65; cursor:wait;}
.manual-call-link {margin-top:12px; color:var(--app-text-muted); font-size:12px;}
.manual-call-link textarea {width:100%; min-height:90px; margin-top:6px; padding:10px; border:1px solid var(--app-border); border-radius:8px; background:var(--app-surface); color:var(--app-text); font-size:12px;}

.text-cta {
  cursor: default;
}

.availability-status {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 18px 0;
  padding: 16px;
  border: 1px solid rgba(40, 168, 121, 0.3);
  border-radius: 14px;
  background: rgba(40, 168, 121, 0.08);
  color: var(--theme-text, #0f2557);
}

.availability-status span {
  color: var(--theme-text-muted, #6d7c96);
  font-size: 13px;
}

.join-call-button {
  width: 100%;
  margin-top: 8px;
  padding: 13px 16px;
  border: 0;
  border-radius: 12px;
  background: #2f85d8;
  color: #fff;
  font-weight: 700;
}

.join-call-note {
  margin: 10px 0 0;
  color: var(--app-text-muted, #6f7f96);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
}

.join-call-button:disabled {
  opacity: 0.6;
}

</style>
